export default __webpack_public_path__ + "static/media/480_dummy2016-consulting01-de.ad49e27a.png";